shadow$provide[121] = function(require,module,exports) {
var require$stats_DOT_js = require("stats.js");
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("stats", {listen:["pre", "post"], install:function(three) {
  const stats = this.stats = new require$stats_DOT_js.default();
  const style = stats.domElement.style;
  style.position = "absolute";
  style.top = style.left = 0;
  three.element.appendChild(stats.domElement);
  three.stats = stats;
}, uninstall:function(three) {
  this.stats.domElement.remove();
  delete three.stats;
}, pre:function(_event, _three) {
  this.stats.begin();
}, post:function(_event, _three) {
  this.stats.end();
},});

};